import { useEffect, useState } from 'react';

import { useBridgewayApi } from '@/api/BridgewayApi';
import { useUserId } from '@/auth/UserIdContext';

export type EmailTemplateDoc = {
	id: string;
	name?: string | null;
	thumbnail_link?: string | null;
};

type UseEmailTemplatesResult = {
	templates: EmailTemplateDoc[];
	isLoading: boolean;
	error: string | null;
};

export function useEmailTemplates(): UseEmailTemplatesResult {
	const bridgewayApi = useBridgewayApi();
	const userId = useUserId();
	const [templates, setTemplates] = useState<EmailTemplateDoc[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!userId) {
			return;
		}
		let cancelled = false;
		setIsLoading(true);
		setError(null);
		bridgewayApi
			.get<EmailTemplateDoc[]>(`/api/user/${userId}/email/templates`)
			.then((rows) => {
				if (cancelled) return;
				setTemplates(rows ?? []);
				setIsLoading(false);
			})
			.catch((err) => {
				if (cancelled) return;
				setError(
					err instanceof Error ? err.message : 'Failed to load templates',
				);
				setIsLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [bridgewayApi, userId]);

	return { templates, isLoading, error };
}
